module.exports = __webpack_public_path__ + "img/flag-BO.193943c9.svg";